export default "__VITE_ASSET__BpTfpZNi__"